import {normalize, schema} from 'normalizr';

export const fetchManyCase = (builder, asyncThunk, entityKey) => {
    builder.addCase(asyncThunk.pending, (state) => {
        state.loading = true;
    });

    builder.addCase(asyncThunk.fulfilled, (state, action) => {
        state.loading = false;

        const entitySchema = new schema.Entity(entityKey);
        const arrayOfRecords = new schema.Array(entitySchema);

        const normalized = normalize(action.payload, arrayOfRecords);
        const {entities, result: ids} = normalized;
        state.byId = {...entities[entityKey]};
        state.ids = [...new Set(ids)];
        state.totalCount = ids.length;
    });

    builder.addCase(asyncThunk.rejected, (state, action) => {
        state.byId = {};
        state.ids = [];
        state.loading = false;
        state.error = action.error.message;
    });
};

export const fetchOneCase = (builder, asyncThunk) => {
    builder.addCase(asyncThunk.pending, (state) => {
        state.loading = true;
    });

    builder.addCase(asyncThunk.fulfilled, (state, action) => {
        state.byId[action.payload.id] = action.payload;
        state.loading = false;
    });

    builder.addCase(asyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
    });
};

export const saveOneCase = (builder, asyncThunk) => {
    builder.addCase(asyncThunk.pending, (state) => {
        state.loading = true;
    });

    builder.addCase(asyncThunk.fulfilled, (state, action) => {
        const {payload: record} = action;

        if (typeof record.uuid !== 'undefined') {
            state.byId[record.uuid] = record;
            state.ids.push(record.uuid);
        } else {
            state.byId[record.id] = record;
            state.ids.push(record.id);
        }

        state.ids = [...new Set(state.ids)];
        state.totalCount = state.ids.length;

        state.loading = false;
    });

    builder.addCase(asyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
    });
};

export const updateOneCase = (builder, asyncThunk) => {
    builder.addCase(asyncThunk.pending, (state) => {
        state.loading = true;
    });

    builder.addCase(asyncThunk.fulfilled, (state, action) => {
        const {payload: record} = action;

        if (typeof record.uuid !== 'undefined') {
            state.byId[record.uuid] = record;
        } else {
            state.byId[record.id] = record;
        }
        state.loading = false;
    });

    builder.addCase(asyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
    });
};

export const deleteOneCase = (builder, asyncThunk) => {
    builder.addCase(asyncThunk.pending, (state) => {
        state.loading = true;
    });

    builder.addCase(asyncThunk.fulfilled, (state, action) => {
        const {payload: recordId} = action;

        delete state.byId[recordId];
        state.ids = state.ids.filter(
            (item) => item.toString() !== recordId.toString()
        );
        state.totalCount = state.ids.length;

        state.loading = false;
    });

    builder.addCase(asyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
    });
};

export const deleteAllCase = (builder, asyncThunk) => {
    builder.addCase(asyncThunk.pending, (state) => {
        state.loading = true;
    });

    builder.addCase(asyncThunk.fulfilled, (state) => {
        state.byId = {};
        state.ids = [];
        state.totalCount = state.ids.length;

        state.loading = false;
    });

    builder.addCase(asyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
    });
};
